import { ArticleColor } from '../../ArticleColor';

export class ArticleColorPersistenceMapper {
  public static toDto = (color: ArticleColor): SimpleProjectServiceAPI.ArticleColorDto => ({
    ralValue: color.ralValue,
    affectedMaterial: color.affectedMaterial
  });

  public static toDomain = (dto: SimpleProjectServiceAPI.ArticleColorDto): ArticleColor => ({
    ralValue: dto.ralValue,
    affectedMaterial: dto.affectedMaterial,
    definition: undefined
  });
}
